import React from 'react';
import { Fade } from '../../Transitions';
import Icon from '../../Icon/Icon';
import classnames from 'classnames';

import './Modal.scss';

export interface ModalProps {
    /**
     * Tag
     * @default 'div'
     */
    tag?: any;
    /**
     * Is opened modal
     * @default true
     */
    opened?: boolean;
    /**
     * Show backdrop modal
     * @default true
     */
    backdrop?: boolean;
    /**
     * Fade animation
     * @default true
     */
    fade?: boolean;
    /**
     * Full screen
     * @default false
     */
    fullscreen?: boolean;
    /**
     * Centered dialog modal
     * @default false
     */
    centered?: boolean;
    /**
     * Show close icon
     * @default false
     */
    close?: boolean;
    /**
     * Close icon props
     */
    closeProps?: any;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style Modal
     */
    style?: any;
    /**
     * Slot component
     */
    children?: React.ReactNode;
    /**
     * onClose function
     */
    onClose?(): any;
    /**
     * onClickBackdrop function
     */
    onClickBackdrop?(): any;
    /**
     * onEnter function
     */
    onEnter?(node: any, isAppearing: any): any;
    /**
     * onExit function
     */
    onExit?(node: any): any;
}

const Modal: React.FC<ModalProps> = ({
    tag: Tag = 'div',
    opened = false,
    backdrop = true,
    fade = true,
    fullscreen = false,
    centered = false,
    close = false,
    closeProps = {},
    className,
    style = {},
    children,
    onClose = () => {},
    onClickBackdrop = () => {},
    onEnter = () => {},
    onExit = () => {},
}) => {
    const Backdrop: any = () =>
        backdrop &&
        (fade ? (
            <Fade in={opened && !!backdrop} className={classnames('modal-backdrop')} onClick={onClickBackdrop} />
        ) : (
            <div className={classnames('modal-backdrop', 'show')} onClick={onClickBackdrop} />
        ));

    return (
        <Tag style={style}>
            <Fade
                in={opened}
                onEntered={onEnter}
                onExited={onExit}
                className={classnames('modal', className, { centered, fullscreen })}
                style={{ display: opened ? 'block' : 'none' }}
            >
                <div className={classnames('modal-dialog', { fullscreen })}>
                    {opened && (
                        <div className={classnames('modal-content', { fullscreen })}>
                            {children}
                            {close && (
                                <Icon
                                    name="x"
                                    size={24}
                                    color="gray"
                                    clickable
                                    className="modal-close"
                                    {...closeProps}
                                    onClick={onClose}
                                />
                            )}
                        </div>
                    )}
                </div>
            </Fade>
            {opened && <Backdrop />}
        </Tag>
    );
};

export default Modal;
